module.exports = __webpack_public_path__ + "img/wide.90eb2fcc.jpg";